import { createReducer } from '@reduxjs/toolkit'
import update from '@scoir/immutability'
import { find, findIndex, get, map, orderBy } from 'lodash'

import userTypes from '../user/types'
import calendarTypes from './types'

const hydrateState = (state, calendars) => {
  const formattedCalendars = map(calendars, (record) => {
    const newCalendar = {
      id: record.Id,
      label: record.Label,
    }
    const currentCalendarState = find(state, { id: record.Id })
    newCalendar.visible = !currentCalendarState || currentCalendarState.visible
    return newCalendar
  })
  return orderBy(formattedCalendars, 'id', 'asc')
}

const setVisibility = (state, id, newValue) => {
  const idx = findIndex(state, { id })
  return update(state, {
    [idx]: {
      visible: {
        $set: newValue,
      },
    },
  })
}

export default createReducer([], {
  [userTypes.FETCH_USER_SUCCESS]: (state, action) => {
    return hydrateState(state, get(action.payload, 'HighSchool.CalendarConfig.ReadCalendars', {}))
  },
  [userTypes.UPDATE_USER_SUCCESS]: (state, action) => {
    return hydrateState(state, get(action.payload, 'HighSchool.CalendarConfig.ReadCalendars', {}))
  },
  [calendarTypes.SHOW_LINKED_CALENDAR]: (state, action) => {
    return setVisibility(state, action.payload, true)
  },
  [calendarTypes.HIDE_LINKED_CALENDAR]: (state, action) => {
    return setVisibility(state, action.payload, false)
  },
})
